import styled from 'styled-components';
import { rem } from '@nowsta/tempo-ds';

export const Tabs = styled.div`
  display: flex;
  gap: ${rem(24)};
`;
